import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const clearCopResolutions = api(async function clearCopResolutions({ codeOfPracticeId }) {
    return mutate(
        gql`
            mutation ClearCopResolutions($codeOfPracticeId: ID!) {
                clearCopResolutions(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "clearCopResolutions" }
    )
})
